
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>In der Kirche an einem Kind vergangen?</h4>
    <p>
  William W. ist Beizer. Entgegen aller Bedenken der Behörden hat er ein Lokal in Olten übernommen, «Palacio de la Paz»
  nennt er es. Direkt gegenüber, so ist es auf Google-Maps ersichtlich, liegt ein Kinderspielplatz.
    </p>
    <p>
  Die Bewährungshilfe hält laut Untersuchungsbericht fest, der 45-Jährige sei «mit vollem Elan an der Instandstellung
  des Lokals». Es bestünden keine Hinweise auf eine Krise. Ende August erfolgt diese Einschätzung. In der gleichen Woche
  soll es laut Staatsanwaltschaft zum nächsten Übergriff gekommen sein, nun in der Friedenskirche Olten. «Konkret begab
  sich der Beschuldigte nach einem Gottesdienst in einen separaten Raum, wo Kinder der Kirchenmitglieder während des
  Gottesdienstes betreut werden», steht in der Anklage. Der 45-Jährige habe alle nach draussen geschickt, bis auf einen
  Buben. Es ist der jüngere der beiden Knaben, an denen sich W. schon im Juli während der Hochzeitsvorbereitungen
  vergangen haben soll. Der Beschuldigte habe das Licht gelöscht und sich am Opfer vergriffen, so die Anklage. Sie
  lautet auch hier auf sexuelle Handlungen mit einem Kind und auf Schändung. W. bestreitet diese Vorwürfe ebenfalls.
  Demnächst muss das Gericht sie beurteilen.
    </p>
    <p>
  Im September ist die GPS-Überwachung erneut unterbrochen. Die Behörden ermahnen W. wegen Verstössen gegen Auflagen. Es
  ist bereits die 13. Verwarnung. Ein Antrag auf nachträgliche Verwahrung erfolgt nach wie vor nicht.
    </p>
    <Image file={require('images/olten.jpg')} source='In der Friedenskirche in Olten soll es zu einem Übergriff gekommen sein. (Kurt Zwahlen/flickr)' mdxType="Image" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;